module.exports = __webpack_public_path__ + "static/media/ruler-horizontal.dbc16c90.svg";